import React from 'react'

function Equalizer() {
  return (
    <svg width={64} height={64} viewBox="0 0 64 64" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32 53.334c2.933 0 5.333-2.4 5.333-5.334V16c0-2.933-2.4-5.333-5.333-5.333-2.933 0-5.333 2.4-5.333 5.333v32c0 2.934 2.4 5.334 5.333 5.334zm-16 0c2.933 0 5.333-2.4 5.333-5.334V37.334C21.333 34.4 18.933 32 16 32c-2.933 0-5.333 2.4-5.333 5.334V48c0 2.934 2.4 5.334 5.333 5.334zM42.667 48V29.334C42.667 26.4 45.067 24 48 24c2.933 0 5.333 2.4 5.333 5.334V48c0 2.934-2.4 5.334-5.333 5.334-2.933 0-5.333-2.4-5.333-5.334z"
        fill="#737373"
      />
    </svg>
  )
}

export default React.memo(Equalizer)
